module.exports = __webpack_public_path__ + "img/fs_erji.fb7c3217.png";